module.exports = __webpack_public_path__ + "static/media/trading-view-image.1fc5ad44.svg";